import { getCsrfValue } from "~/common/utils/ApiHelper";
import { resolveApiUrl } from "~/utils/url/urlResolver";
import { WISHLIST_PAGE } from "~/utils/url/staticUrls";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { COPY_WISHLIST_STATUS_PARAM } from "~/features/wishlist/redux/actionTypes";

export function sendCopySharedWishlist({ wishlistId }: { wishlistId: string }) {
  const apiUrl = resolveApiUrl(`/copySharedWishlistManual?wishlistId=${wishlistId}`);
  let url = WISHLIST_PAGE;
  return fetch(apiUrl, {
    method: "GET",
    cache: "no-cache",
    credentials: "same-origin", // include, omit
    mode: "cors", // no-cors, same-origin
    referrer: "no-referrer", // client
    headers: {
      "content-type": "application/json",
      CSRFToken: getCsrfValue(),
    },
  }).then((response) => {
    if (!response.ok) {
      url += `?${COPY_WISHLIST_STATUS_PARAM}=false`;
      redirectToUrl(url);
    } else {
      return response.json();
    }
  });
}
